module.exports = __webpack_public_path__ + "img/graduate-zhongpeizhang-lecture.61c87565.jpg";